import { useReveal } from "@/lib/useReveal";

const KEY_FACTS = [
    "20 лет в управлении ИТ-разработкой на заказ",
    "20+ проектов полного цикла",
    "Текучесть в командах 8%",
    "Вовлечённость команды 4,2 из 5 по Gallup",
];

const POINTS = [
    "Прошла путь от разработчика до операционного партнёра собственников ИТ-компаний — знаю, как устроена разработка изнутри.",
    "Запускала и масштабировала B2B-продукты в РФ и США — понимаю обе культуры и оба типа команд.",
    "Работаю как партнёр, а не как внешний аудитор: моя задача — чтобы изменения остались внутри компании, а не уехали со мной.",
    "Не продаю фреймворки. Собираю операционную модель под ваш контекст: размер, рынок, людей, бюджеты.",
];

export const About = () => {
    const ref = useReveal();
    return (
        <section
            id="about"
            data-testid="about-section"
            className="relative py-28 sm:py-40 bg-[#F4F1EA] border-t border-[#1B2A41]/15 overflow-hidden"
        >
            <div ref={ref} className="vnutri-reveal max-w-[1440px] mx-auto px-6 sm:px-10 lg:px-16">
                <div className="grid lg:grid-cols-12 gap-10 lg:gap-20 items-start">
                    {/* Left — eyebrow + title + portrait */}
                    <div className="lg:col-span-5">
                        <div className="flex items-center gap-4 mb-6">
                            <span className="w-12 h-px bg-[#C46342]" />
                            <span className="text-[11px] tracking-[0.4em] uppercase font-semibold text-[#C46342]">
                                04 · Обо мне
                            </span>
                        </div>
                        <h2
                            data-testid="about-title"
                            className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl tracking-[-0.03em] text-[#1B2A41] font-extralight leading-[1.02] mb-12"
                        >
                            Елена{" "}
                            <span className="font-semibold">Кулакова</span>
                        </h2>

                        <div
                            data-testid="about-portrait"
                            className="relative w-full max-w-md mx-auto lg:mx-0"
                        >
                            <img
                                src="/img/elena-v4.png"
                                alt="Елена Кулакова"
                                className="block w-full h-auto bg-[#F4F1EA] shadow-[0_24px_55px_-25px_rgba(27,42,65,0.35),0_8px_18px_-12px_rgba(27,42,65,0.22)]"
                                draggable="false"
                            />
                        </div>
                    </div>

                    {/* Right — lead + facts + points */}
                    <div className="lg:col-span-7 lg:pt-16">
                        <p className="text-xl sm:text-2xl lg:text-3xl leading-[1.35] text-[#1B2A41] font-light tracking-[-0.01em] max-w-2xl">
                            Под брендом «Внутри» я работаю с руководителями, которые хотят{" "}
                            <span className="text-[#C46342] font-medium">
                                управлять разработкой
                            </span>
                            , а не зависеть от неё.
                        </p>

                        <ul
                            data-testid="about-key-facts"
                            className="mt-10 grid sm:grid-cols-2 gap-x-10 gap-y-4 max-w-2xl"
                        >
                            {KEY_FACTS.map((f, i) => (
                                <li
                                    key={i}
                                    data-testid={`about-fact-${i}`}
                                    className="flex items-baseline gap-3 text-base text-[#1B2A41]"
                                >
                                    <span className="w-1.5 h-1.5 bg-[#C46342] shrink-0 translate-y-[-2px]" />
                                    <span className="leading-snug">{f}</span>
                                </li>
                            ))}
                        </ul>

                        <div className="mt-12 space-y-8">
                            {POINTS.map((p, i) => (
                                <div
                                    key={i}
                                    data-testid={`about-point-${i}`}
                                    className="flex gap-6 items-start group border-t border-[#1B2A41]/15 pt-6"
                                >
                                    <span className="shrink-0 w-10 text-[11px] tracking-[0.24em] uppercase font-semibold text-[#C46342] pt-1.5">
                                        0{i + 1}
                                    </span>
                                    <p className="text-base lg:text-lg leading-[1.7] text-[#1B2A41]/85 font-light">
                                        {p}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
